import React from "react";
import { useTx } from "../../context/TxContext";
import { useToast } from "../common/Toast";
import { parseError } from "../../utils/errors";

// paused: bool, getContract(signer) -> contract with pause()/unpause()
export default function PauseControl({ paused, getContract, signer, onDone }) {
  const { run } = useTx();
  const toast = useToast();

  const act = async (which) => {
    if (!signer) return;
    try {
      await run(which === "pause" ? "Pausing" : "Unpausing", async () => {
        const c = getContract(signer);
        const tx = which === "pause" ? await c.pause() : await c.unpause();
        await tx.wait();
      });
      toast.success(which === "pause" ? "Contract paused." : "Contract unpaused.");
      onDone && onDone();
    } catch (e) {
      toast.error(parseError(e));
    }
  };

  return (
    <div className="card adm-card">
      <div className="adm-head">
        <span className="adm-ico gold"><span style={{ fontWeight: 800 }}>⏸</span></span>
        <div>
          <div className="adm-title">Pause Control</div>
          <div className="adm-desc muted">
            Status:{" "}
            <strong style={{ color: paused ? "var(--danger)" : "var(--success)" }}>
              {paused === undefined ? "—" : paused ? "PAUSED" : "ACTIVE"}
            </strong>
          </div>
        </div>
      </div>
      <div className="grid grid-2">
        <button className="btn btn-danger" onClick={() => act("pause")} disabled={paused === true}>Pause</button>
        <button className="btn btn-success" onClick={() => act("unpause")} disabled={paused === false}>Unpause</button>
      </div>
    </div>
  );
}
